import _ from 'lodash';
import { DateTime } from 'luxon';
import { INPUT_DATE } from './formats';

export const fromDateInputToJsDate = (date: string): Date => {
    return DateTime.fromFormat(date, INPUT_DATE).toJSDate();
};
